import actionTypes from 'SRC/modules/redux/actionTypes'

export const setUserInfo = info => ({
  type: actionTypes.SET_USER_INFO,
  payload: info
})
